
<template>
  <div
    class="button-box-images m-0 p-0">
    <button
      v-tooltip="'Add New'"
      class="bm-small-btns custom-icon d-flex align-items-center justify-content-center tooltip-button"
      @click="changeSelection(getSelection)"
    >
      <icon :name="buttonIcon" />
    </button>

  </div>
</template>
<script>
import Vue from 'vue';
import { VTooltip } from 'v-tooltip';
import EventBus from '@/EventBus';

Vue.directive('tooltip', VTooltip);
export default {
  name:       'PanelButtons',
  components: {
  },

  props: {
    buttonIcon:      String,
    id:              [Number, String],
    variation:       String,
    toolTipText:     String,
    selection:       Boolean,
    changeSelection: Function,
  },
  computed: {
    ButtonIcons() {
      return `src/styles/Icons/icons.svg#${this.buttonIcon}`;
    },
    getSelection() {
      return this.selection;
    },

  },
  mounted() {
    EventBus.$on('getActive', this.getActive);
  },
  methods: {
    getActive() {

    },
    showTooltip() {
      EventBus.$emit('checkToolTip', this.id);
    },
    hideTooltip() {
      EventBus.$emit('triggerHide');
    },

  },

};

</script>
<style  lang="scss">

</style>
